<template>
  <div :class="getClass">
    <template v-if="canFullscreen">
      <Tooltip v-if="fullScreen" :title="t('component.modal.restore')" placement="bottom">
        <FullscreenExitOutlined role="full" @click="handleFullScreen" />
      </Tooltip>
      <Tooltip v-else :title="t('component.modal.maximize')" placement="bottom">
        <FullscreenOutlined role="close" @click="handleFullScreen" />
      </Tooltip>
    </template>
    <CloseOutlined v-if="PADMode" @click="emit('cancel', $event)" />
    <Tooltip v-else :title="t('component.modal.close')" placement="bottom">
      <CloseOutlined @click="emit('cancel', $event)" />
    </Tooltip>
  </div>
</template>
<script lang="ts" setup>
  import { CloseOutlined, FullscreenExitOutlined, FullscreenOutlined } from '@ant-design/icons-vue';
  import { Tooltip } from 'ant-design-vue';
  import { computed } from 'vue';
  import { useDesign } from '@mts/hooks/web/useDesign';
  import { t } from '@mts/hooks/web/useI18n';
  import { PADMode } from '@mts/utils/env';

  defineOptions({ name: 'ModalClose' });

  const props = defineProps({
    canFullscreen: { type: Boolean, default: true },
    fullScreen: { type: Boolean },
  });

  const emit = defineEmits(['cancel', 'fullscreen']);

  const { prefixCls } = useDesign('basic-modal-close');

  const getClass = computed(() => {
    return [
      prefixCls,
      `${prefixCls}--custom gap-8px`,
      {
        [`${prefixCls}--can-full`]: props.canFullscreen,
      },
    ];
  });

  function handleFullScreen(e: Event) {
    e?.stopPropagation();
    e?.preventDefault();
    emit('fullscreen');
  }
</script>
<style lang="less">
  @prefix-cls: ~'@{namespace}-basic-modal-close';
  .@{prefix-cls} {
    display: flex;
    align-items: center;
    height: 100%;

    & span {
      padding: 4px;
      font-size: 16px;

      &:hover {
        color: @primary-color;
      }
    }

    & span:last-child {
      margin-right: 4px;

      &:hover {
        color: @error-color;
      }
    }
  }
</style>
